<template>
  <span v-if="show" class="color-card-mark" title="已裁料做色卡">色卡</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  /** 库存行：has_color_card 为真即显示 */
  row: { type: Object, default: null },
  /** 直接传布尔/真值 */
  marked: { type: [Boolean, String, Number], default: null }
})

const show = computed(() => {
  if (props.marked != null && props.marked !== '') {
    return props.marked === true || props.marked === 1 || props.marked === '1' || props.marked === 'true'
  }
  const r = props.row
  if (!r) return false
  return r.has_color_card === true || r.has_color_card === 1 || r.has_color_card === '1'
})
</script>

<style scoped>
.color-card-mark {
  color: #c0392b;
  font-weight: 600;
  font-size: 0.92em;
  margin-left: 4px;
  white-space: nowrap;
}
</style>
